export default "__VITE_ASSET__fGEObisJ__"